<template>
    <div class="row">
        <div class="col-md-6">
            <div class="card">
                <div class="card-header bg-default">
                    <h3 class="card-title"><i class="fas fa-list mr-2"></i>{{ $t('general.importar') }}</h3>
                    <div class="card-tools">
                        <button type="button" @click="importartrabajos()" class="btn btn-success btn-xs">{{
                            $t('general.importar') }} </button>
                           
                    </div>
                </div>
                <div class="card-body">
                     <button type="button" style="margin-bottom:10px" @click="selectAll()" class="btn btn-success btn-xs">Seleccionar todos </button> 
                    <v-select taggable multiple :options="listatrabajos.filter(o => trabajo_lista.indexOf(o) < 0)" v-model="trabajo_lista" placeholder="Seleccione trabajo"
                         :closeOnSelect="false" />
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card">
                <div class="card-header bg-default">
                    <h3 class="card-title"><i class="fas fa-list mr-2"></i>{{ $t('general.anadir') }}</h3>
                    <div class="card-tools">
                        <button type="button" @click="anyadirtrabajobaremo()" class="btn btn-success btn-xs">{{
                            $t('general.anadir') }} </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <v-select v-model="especialidadseleccionada" taggable placeholder="Seleccione especialidad"
                                :options="listaespecialidades" label="nombre" track-by="id" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <v-select
                                :closeOnSelect="false"
                                v-model="trabajo_especialidad_seleccionada"
                                taggable
                                multiple
                                placeholder="Seleccione trabajos de la especialidad"
                                :options="trabajos_especialidad"
                                track-by="idBaremo"
                                :get-option-label="filtroBaremo"
                                >
                                <template #selected-option="option">
                                    {{ option.codigo }} - {{ option.nombre }}&nbsp;({{ option.precio }}€)
                                </template>
                                <template #option="option">
                                    {{ option.codigo }} - {{ option.nombre }}&nbsp;({{ option.precio }}€)
                                </template>
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="card" style="width: 100%;">
                <div class="input-group" v-for="grupo in Object.entries(listatrabajosporespecialidad)" :key="grupo[0]">
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="min-width: 250px;">{{ grupo[0] }}</span>
                    </div>
                    <span class="form-control" style="text-align:right;max-width:250px;">{{ Math.round(totalesespecialidad[grupo[0]] * 100) / 100 }}</span>
                    <span class="form-control" style="text-align:right;max-width:250px;">{{ Math.round(totalesespecialidad_iva[grupo[0]] * 100) / 100 }}</span>
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="fas fa-euro-sign"></i></span>
                    </div>
                </div>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" style="min-width:250px;"><b>Total</b></span>
                    </div>
                    <span class="form-control" style="text-align:right;max-width:250px;">{{ Math.round(total_sin_iva * 100) / 100 }}</span>
                    <span class="form-control" style="text-align:right;max-width:250px;">{{ Math.round(total * 100) / 100 }}</span>
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="fas fa-euro-sign"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="input-group" style="width: auto;">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('general.impuesto') }}</span>
                </div>
                <select class="form-control input-sm" v-model="impuestoSelec">
                    <option v-for="impuesto in impuestos" :key="impuesto.id" :value="impuesto.valor_iva">{{
                        impuesto.valor_iva }}</option>
                </select>
            </div>
            <div class="input-group" style="width: auto;">
                <div class="input-group-prepend">
                    <span class="input-group-text">Destinatario</span>
                </div>
                <select class="form-control input-sm" v-model="destSelec">
                    <option value="Compañia">{{ $t('general.compania') }}</option>
                    <option value="Cliente">{{ $t('general.asegurado') }}</option>
                </select>
            </div>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-12">
            <div class="card" v-for="grupo in Object.entries(listatrabajosporespecialidad)" :key="grupo[0]">
                <div class="card-header bg-gray">
                    <h3 class="card-title">{{ grupo[0] }}</h3>
                </div>
                <div class="card-body">
                    <div class="col-md-12">
                        <servicio-presupuesto-concepto 
                            :servicio="servicio" 
                            v-for="trabajo in grupo[1]" 
                            ref="presus" 
                            :trabajo="trabajo" 
                            :id="id"
                            :listaespecialidadesnombre="listaespecialidadesnombre" 
                            :seleccionado="seleccionado"
                            @actualizarconcepto="actualizarconcepto" 
                            :key="trabajo.datos.idtrabajo_presupuesto" 
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card" style="width: 100%;">
                <div class="card-header bg-gray">
                    <div style="display: flex; justify-content: space-between">
                        <h3 class="card-title">
                            Notas Operarios
                        </h3>
                        <button class="btn btn-tool ampliar-asegurado" v-on:click="notasVisibles = !notasVisibles" v-if="!notasVisibles">
                            <i class="fas fa-plus"></i>
                        </button>
                        <button class="btn btn-tool reducir-asegurado" v-on:click="notasVisibles = !notasVisibles" v-if="notasVisibles">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body" v-if="notasVisibles">
                    <div v-if="notas.length == 0">
                        <div class="direct-chat-msg">
                            <div class="direct-chat-infos clearfix">
                                <span class="direct-chat-timestamp float-left" style="margin-left: 50px ;">No hay notas
                                    disponibles</span>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="direct-chat-msg" v-for="nota in notas" :key="nota.id_nota">                    
                            <div class="direct-chat-infos clearfix">
                                <span class="direct-chat-timestamp float-left" style="margin-left: 50px ;">{{
                                    nota.fecha }}</span>
                            </div>
                            <img class="direct-chat-img" src="https://plataforma.apuyen.app/img/trabajadora.jpg"
                                alt="message user image">
                            <div class="direct-chat-text" style="position: relative;">
                                <div class="custom-control custom-switch"
                                    style="position: absolute; right: 0; top: 0; margin-right:10px;margin-top:5px;">
                                    <input type="checkbox"
                                        @change="cambiarEstadoNota(nota.id_nota, nota.revisado)"
                                        :id="nota.id_nota" v-model="nota.revisado" class="custom-control-input">
                                    <label class="custom-control-label" :for="nota.id_nota">Revisada</label>
                                </div>
                                <p style="white-space: preserve-breaks;margin-bottom: 3px;"
                                    v-html="nota.tipo_cliente + '<br>' + cambiarmensaje(nota.texto)"></p>
                                <div v-if="nota.archivos?.length >0" style="padding: 2px;">
                                    <div class="card card-default" style="margin-bottom: 3px">
                                        <div class="card-header ch" style="padding-top: 5px;padding-bottom: 5px;">
                                            <h4 class="card-title">{{$t('general.archivos')}}</h4>
                                            <!--  <Button icon="fas fa-download" style="font-size: 10px;margin-left: 60%;" class="p-button-primary" label="Descargar todo" @click="archivos = nota.archivos; downloadFileWithAnchor()" />  -->
                                        </div>
                                        <div class="card-body" style="padding-bottom: 7px; padding-top: 7px;">
                                            <div class="row"
                                                style="justify-content: space-around;row-gap: 10px;">
                                                <Galleria v-model:activeIndex="nota.activeIndex"
                                                    v-model:visible="nota.displayCustom"
                                                    :responsiveOptions="responsiveOptions"
                                                    :value="nota.archivos" :numVisible="7"
                                                    containerStyle="max-width: 850px" :circular="true"
                                                    :fullScreen="true" :showItemNavigators="true"
                                                    :showThumbnails="false">
                                                    <template #item="slotProps">
                                                        <img v-if="urlglobal != 'null.pwgs.app'" class="imgcarr"
                                                            :src='slotProps.item.url_completa_descarga' preview
                                                            :alt="slotProps.item.descripcion" />
                                                        <img v-if="urlglobal == 'null.pwgs.app'" class="imgcarr"
                                                            :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + slotProps.item.documento + "&servicio=" +id'
                                                            preview :alt="slotProps.item.descripcion" />
                                                    </template>
                                                    <template #thumbnail="slotProps">
                                                        <img v-if="urlglobal != 'null.pwgs.app'" class="imgcarr"
                                                            :src='slotProps.item.url_completa_descarga' preview
                                                            :alt="slotProps.item.descripcion" />
                                                        <img v-if="urlglobal == 'null.pwgs.app'" class="imgcarr"
                                                            :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + slotProps.item.documento + "&servicio=" +id'
                                                            preview :alt="slotProps.item.descripcion" />
                                                    </template>
                                                </Galleria>
                                                <div v-for="(archivos, index) in nota.archivos" :key="archivos">
                                                    <!-- <a download :id="archivos.id_documento" v-if="urlglobal == 'null.pwgs.app'" :href='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" + id'><i class="fas fa-download"></i></a>-->
                                                    <a download target="_blank" :id="archivos.id_documento"
                                                        :href='archivos.url_completa_descarga'><i
                                                            class="fas fa-download"></i></a>
                                                    <i title="Mostrar descripción"
                                                        @mouseover="descripcionarchivo = archivos.descripcion; toggle($event)"
                                                        style="margin-left: 20%;font-size: 1.2rem;color: #007bff;cursor: pointer;"
                                                        class="fas fa-info-circle"></i>
                                                    <div style="display: grid" v-if="archivos.image==''">
                                                        <i class="fas fa-file fa-6x"></i>
        
                                                    </div>
                                                    <div v-else-if="archivos.propiedad_cliente!=0">
                                                        <div class="image-container">
                                                            <img style="width: 80px; height: 100px;"
                                                                @click="imageClick(nota, index)"
                                                                v-if="urlglobal != 'null.pwgs.app'"
                                                                :src='archivos.url_completa_descarga'
                                                                width="100" preview
                                                                :alt="archivos.descripcion" />
                                                            <img style="width: 80px; height: 100px;"
                                                                @click="imageClick(nota, index)"
                                                                v-if="urlglobal == 'null.pwgs.app'"
                                                                :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + archivos.documento + "&servicio=" +id'
                                                                width="100" preview
                                                                :alt="archivos.descripcion" />
                                                            <div v-if="archivos.cuando">
                                                                <span style="width: 80px;" v-if="archivos.cuando=='despues'"
                                                                    class="badge bg-danger bg-blue">después</span>
                                                                <span style="width: 80px;" v-else class="badge bg-danger bg-blue">{{
                                                                    archivos.cuando }}</span>
                                                            </div>
                                                            <!--  <div style="width: 350px;"  class="image-zoom-overlay">
                                                                <img style="width: 300px; height: 300px;" @click="imageClick(nota, index)" v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga' :alt="archivos.descripcion" />
                                                                <img style="width: 300px; height: 300px;" @click="imageClick(nota, index)" v-if="urlglobal == 'null.pwgs.app'" :src='"https://desarrollo.pwgs.app/documentos.php?documento="  + archivos.documento + "&servicio=" +id' :alt="archivos.descripcion" />
                                                            </div>-->
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <div class="image-container">
                                                            <img style="width: 80px; height: 100px;"
                                                                @click="imageClick(nota, index)"
                                                                v-if="urlglobal != 'null.pwgs.app'"
                                                                :src='archivos.url_completa_descarga'
                                                                width="100" preview
                                                                :alt="archivos.descripcion" />
                                                            <img style="width: 80px; height: 100px;"
                                                                @click="imageClick(nota, index)"
                                                                v-if="urlglobal == 'null.pwgs.app'"
                                                                :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id'
                                                                width="100" preview
                                                                :alt="archivos.descripcion" />
                                                            <div v-if="archivos.cuando">
                                                                <span style="width: 80px;" v-if="archivos.cuando=='despues'"
                                                                    class="badge bg-danger bg-blue">después</span>
                                                                <span style="width: 80px;" v-else class="badge bg-danger bg-blue">{{
                                                                    archivos.cuando }}</span>
                                                            </div>
                                                            <!--  <div style="width: 350px;" class="image-zoom-overlay">
                                                                <img style="width: 300px; height: 300px;" @click="imageClick(nota, index)" v-if="urlglobal != 'null.pwgs.app'" :src='archivos.url_completa_descarga' :alt="archivos.descripcion" />
                                                                <img style="width: 300px; height: 300px;" @click="imageClick(nota, index)" v-if="urlglobal == 'null.pwgs.app'" :src='"https://desarrollo.pwgs.app/documentos.php?documento=" + archivos.documento + "&servicio=" +id' :alt="archivos.descripcion" />
                                                            </div>-->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="nota.alarmas">
                                    <div v-for="alarma in nota.alarmas" :key="alarma">
                                        <p>{{ $t('general.alarma') }}:</p>
                                        <p>{{ $t('general.usuario') }}:{{ nombre_usuario_alarma }} {{
                                            $t('general.remitente2') }}:{{ nombre_remitente_alarma }}</p>
                                        <p>{{ alarma.fecha_alarma }}{{ hora_alarma }}</p>
                                    </div>
                                    <button class="btn btn-default">{{$t('general.editaralarma')}}</button>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>
                <OverlayPanel ref="opdescripcionnotas">
                    <div class="flex flex-column gap-3 w-25rem">
                        <b>Descripción del archivo</b>
                        <p v-html="descripcionarchivo"></p>
                    </div>
                </OverlayPanel>
            </div>
        </div>
    </div>
</template>
<script>
import Galleria from 'primevue/galleria';
import { PwgsApi } from '../../../../../../services/PwgsApi';
import serviciopresupuestoconcepto from './presupuesto_concepto.vue';
import OverlayPanel from 'primevue/overlaypanel';
export default ({
    props: ['seleccionado', 'id', 'idaux','actualizarconceptos','servicio'],
        data() {
        return {
            descripcionarchivo:'',
            notasVisibles: false,
            destSelec:'',
            impuestoSelec:'',
            impuestos:[],
            listatrabajos: [],
            idtrabajos: [],
            listatrabajosid:[],
            listaespecialidadesnombre: [],
            listaespecialidadesid: [],
            listatrabajosporespecialidad: [],
            trabajo_especialidad: [],
            trabajos_especialidad: [],
            trabajo_lista:  [],
            trabajo_listaux: '',
            especialidadseleccionada: '',
            trabajosaux: '',
            especialidadseleccionadaid: '',
            trabajospresupuesto: [],
            especialidades: [],
            especialidadesnombre: [],
            especialidadesbaremo: '',
            idtrabajo:[],
            listaespecialidades: [],
            totalesespecialidad:{},
            totalesespecialidad_iva:{},
            trabajo_especialidad_seleccionada:[],
            total:0,
            total_sin_iva:0,
            notas: [],
        };
    },
    mounted() {
        this.cargarnotas();
        this.cargarImpuestos();
        this.cargartrabajos();
        this.cargarespecialidades();
        this.cargartrabajospresupuesto();
     },
    components: {
        'servicio-presupuesto-concepto': serviciopresupuestoconcepto,
        Galleria,
        OverlayPanel
    },
    methods: {

        imageClick(nota, index) {
            nota.activeIndex = index;
            nota.displayCustom = true;
        },
        cambiarmensaje(mensaje) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(mensaje, "text/html");

            const span = doc.querySelector("span.descripcion-visita");
            if (span) {
                const wrapper = doc.createElement("div");
                wrapper.setAttribute("style", "background:white");
                span.parentNode.insertBefore(wrapper, span);
                wrapper.appendChild(span);
            }

            return doc.body.innerHTML.replaceAll("\u0080", "€");
        },
        toggle(event) {
            this.$refs.opdescripcionnotas.toggle(event);
        },
        async cambiarEstadoNota(id_nota, estadoActual) {
            // Aquí puedes manejar la lógica diferente para marcar y desmarcar
            if (!estadoActual) {
                this.procesarNotaRevisada(id_nota);
            } else {
                this.procesarNotaNoRevisada(id_nota);
            }
            setTimeout(()=>{
                this.cargarnotas();
            }, 1000);
        },
        async procesarNotaNoRevisada(idnota) {
            const api = new PwgsApi();
            let body = {tipo: "trabajos_no_revisados", ids_avisos: [idnota], estado: 1};
            await api.put('/avisos/revisar-avisos', body);
        },
        async procesarNotaRevisada(idnota) {
            const api = new PwgsApi();
            let body = {tipo: "trabajos_no_revisados", ids_avisos: [idnota], estado: 0};
            await api.put('/avisos/revisar-avisos', body);
        },
        async cargarnotas() {
            const api = new PwgsApi();
            // Obtén las notas de la API
            this.notas = await api.get('servicios/' + this.$props.id + '/notas');
            console.log('notas', this.notas);
            // Si notas no es un array, asegúrate de que sea uno
            if (!Array.isArray(this.notas)) {
                this.notas = [];
            }
            
            // Añadir el campo 'revisado' a cada nota
            if(this.notas.length > 0) {
                this.notas = this.notas.filter((nota) => nota.tipo_usuario != 'tramitador');
                console.log('notas2', this.notas);
                this.notas = this.notas.map(nota => {
                    return this.comprobarRevisado(nota);
                });
                console.log('notas3', this.notas);
                for(let nota of this.notas){
                    nota.displayCustom = false;
                    nota.activeIndex = 0;
                }
            }
            console.log('notas4', this.notas);
            this.cargado = true;           
        },
        comprobarRevisado(nota) {
            return {
                ...nota,
                revisado: nota.realizado_operario && nota.realizado_operario.toLowerCase() === "si"
            };
        },
        async actualizarconcepto(id){
            const api = new PwgsApi();            
            const datos = await api.get('presupuestos/' + this.$props.seleccionado.presupuesto.id_presupuesto + '/trabajos');
            var nuevostrabajos = datos.trabajos;
            var encontrado = '';
            nuevostrabajos.forEach(element => {
                if(element.datos.idtrabajo_presupuesto == id){
                    encontrado = element;
                }
            });
            var especialidad = encontrado.datos.nombre_especialidad;           
            for(var trabajo in this.listatrabajosporespecialidad[especialidad]){                               
                if(this.listatrabajosporespecialidad[especialidad][trabajo].datos.idtrabajo_presupuesto == id){
                    //console.log('viejo', this.listatrabajosporespecialidad[especialidad][trabajo]);
                    this.listatrabajosporespecialidad[especialidad][trabajo] = encontrado;
                    //console.log('nuevo', this.listatrabajosporespecialidad[especialidad][trabajo]);
                }
            }
        },
        selectAll(){
            // Copy all v-select's items in your selectedItem array
            this.trabajo_lista = [...this.listatrabajos]
        },
        async cargarImpuestos(){
            const api = new PwgsApi();
            const ress = await api.get('impuestos');
            this.impuestos = ress.datos;
        },
        async cargartrabajos() {
            //   modulos/pwgsapi/index.php/trabajos/:id_servicio/trabajos-servicio
            const api = new PwgsApi;
            this.listatrabajos = [];
            this.idtrabajos = [];
            let subidadatos = { id_servicio: this.$props.id };
            this.trabajosaux = await api.get("trabajos/" + this.$props.id + '/trabajos-servicio/', subidadatos);
            for (let operarios in this.trabajosaux.operario) {
                //console.log("operarios", operarios);                
                for (let trabajo in this.trabajosaux.operario[operarios].trabajos) {
                    //console.log("trabajo", trabajo);
                    this.listatrabajos.push(this.trabajosaux.operario[operarios].trabajos[trabajo].datos.nombre);
                    this.idtrabajos.push(this.trabajosaux.operario[operarios].trabajos[trabajo].datos);
                }                
            }
            for(let proveedores in this.trabajosaux.proveedor){
                for(let trabajo in this.trabajosaux.proveedor[proveedores].trabajos){
                    this.listatrabajos.push(this.trabajosaux.proveedor[proveedores].trabajos[trabajo].datos.nombre);
                    this.idtrabajos.push(this.trabajosaux.proveedor[proveedores].trabajos[trabajo].datos);
                }
            }
        },
        async cargarespecialidades() {
            //GET  modulos/pwgsapi/index.php/especialidades
            const api = new PwgsApi();
            let datos = await api.get('especialidades');
            this.listaespecialidades = datos.datos.map(especialidad => ({
                nombre: especialidad.nombre,
                id: especialidad.idespecialidad
            }));
            this.listaespecialidades = this.listaespecialidades.sort((a, b) => a.nombre.localeCompare(b.nombre));
        },
        async cargartrabajoespecialidad() {
            for (let i = 0; i < this.trabajosaux.length; i++) {
                for (let j = 0; j < this.listaespecialidadesid.especialidadesbaremolength; j++) {
                    if (this.especialidadseleccionada == this.trabajosaux[i].datos.nombre)
                    {
                        this.trabajo_listaux = this.trabajo_listaux.push(this.trabajosaux[i].datos.nombre);
                    }
                }
            }
        },
        async importartrabajos() {
            //POST  modulos/pwgsapi/index.php/presupuestos/:id_presupuesto/importar-trabajo
            console.log("idtrabajos", this.idtrabajos);
            this.idtrabajo = [];
             for (let j = 0; j < this.trabajo_lista.length; j++){
                    for(let i=0; i<this.idtrabajos.length; i++){
                
                    console.log("trabajolista", this.trabajo_lista[j]);
                    if (this.trabajo_lista[j] == this.idtrabajos[i].nombre) {

                        this.idtrabajo.push(this.idtrabajos[i].idtrabajo_servicio);
                    }
                }
            }
                                console.log("trabajoid", this.idtrabajo);

            const api = new PwgsApi();
            let subidadatos2 = { id_servicio: this.$props.id };
            this.trabajosaux = await api.get("trabajos/" + this.$props.id + '/trabajos-servicio/', subidadatos2);
              for (let operarios in this.trabajosaux.operario) {
                {
                      for (let trabajo in this.trabajosaux.operario[operarios].trabajos)
                      {
                        if (this.trabajo_lista == this.trabajosaux.operario[operarios].trabajos[trabajo].datos.nombre) {
                            this.idtrabajo.push(this.trabajosaux.operario[operarios].trabajos[trabajo].datos.idtrabajo_servicio);
                        }
                }
            }
              }
               let result = this.idtrabajo.filter((item,index)=>{
                return this.idtrabajo.indexOf(item) === index;
             })
            this.idtrabajo = result;
            let subidadatos = { ids_trabajos: this.idtrabajo, aplicar_descuento_defecto: '0' }
            try {
            await api.post('presupuestos/' + this.$props.seleccionado.presupuesto.id_presupuesto + '/importar-trabajo', subidadatos);

                
            
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

            this.cargarImpuestos();
            this.cargartrabajos();
            this.cargarespecialidades();
            this.cargartrabajospresupuesto();
            
            }
             this.cargarImpuestos();
            this.cargartrabajos();
            this.cargarespecialidades();
            this.cargartrabajospresupuesto();
           
        },
        async cargartrabajospresupuesto(anadido) { 
            // GET     modulos/pwgsapi/index.php/presupuestos/:id_presupuesto/trabajos
            const api = new PwgsApi;            
            const datos = await api.get('presupuestos/' + this.$props.seleccionado.presupuesto.id_presupuesto + '/trabajos');

            this.total = 0;
            this.total_sin_iva = 0;

            var trabajo_base = 0;
            var trabajo_dto = 0;
            var trabajo_iva = 0;
            var trabajo_total = 0;
            var trabajo_total_iva = 0;

            if(!datos.trabajos){
                this.listatrabajosporespecialidad = [];
            }else{
                console.log("uyuyuyu");
                         //   this.listatrabajosporespecialidad = [];

                this.trabajospresupuesto = datos.trabajos;
                var trabajosSeparados = {};
                for(var trabajo of this.trabajospresupuesto){
                    var especialidad = trabajo.datos.nombre_especialidad;
                    if(!trabajosSeparados[especialidad]){
                        trabajosSeparados[especialidad] = [];
                    }
                    trabajosSeparados[especialidad].push(trabajo);
                }
                if(anadido==true){
                    this.listatrabajosporespecialidad = [];
                }
                setTimeout(() => {
                    this.total = 0;
                    this.total_sin_iva = 0;

                    trabajo_base = 0;
                    trabajo_dto = 0;
                    trabajo_iva = 0;
                    trabajo_total = 0;
                    trabajo_total_iva = 0;

                    this.listatrabajosporespecialidad = trabajosSeparados;
                    //console.log("listatrabajosespecialidad", this.listatrabajosporespecialidad);

                    for (let especialidad in this.listatrabajosporespecialidad) {
                        this.totalesespecialidad[especialidad] = 0;
                        this.totalesespecialidad_iva[especialidad] = 0;

                        for (let i = 0; i < this.listatrabajosporespecialidad[especialidad].length; i++){

                            trabajo_base = 0;
                            trabajo_dto = 0;
                            trabajo_iva = 0;
                            trabajo_total = 0;
                            trabajo_total_iva = 0;

                            trabajo_base = parseFloat(this.listatrabajosporespecialidad[especialidad][i].datos.precio * this.listatrabajosporespecialidad[especialidad][i].datos.cantidad);
                            trabajo_dto = parseFloat(trabajo_base * this.listatrabajosporespecialidad[especialidad][i].datos.descuento / 100);

                            if(this.listatrabajosporespecialidad[especialidad][i].datos.desc_incr > 0){
                                trabajo_total = trabajo_base + trabajo_dto;
                            }else{
                                trabajo_total = trabajo_base - trabajo_dto;
                            }
                            trabajo_iva = trabajo_total * (parseFloat(this.listatrabajosporespecialidad[especialidad][i].datos.iva_trabajo / 100));
                            trabajo_total_iva += trabajo_total + trabajo_iva;

                            /*console.log(this.listatrabajosporespecialidad[especialidad][i].datos.nombre+'_BASE',trabajo_base);
                            console.log(this.listatrabajosporespecialidad[especialidad][i].datos.nombre+'_DTO',trabajo_dto);
                            console.log(this.listatrabajosporespecialidad[especialidad][i].datos.nombre+'_SUBTOTAL',trabajo_total);
                            console.log(this.listatrabajosporespecialidad[especialidad][i].datos.nombre+'_IVA',trabajo_iva);
                            console.log(this.listatrabajosporespecialidad[especialidad][i].datos.nombre+'_TOTAL',trabajo_total_iva);*/

                            this.totalesespecialidad[especialidad] += trabajo_total;
                            this.totalesespecialidad_iva[especialidad] += trabajo_total_iva;
                        }
                        this.total_sin_iva += this.totalesespecialidad[especialidad];
                        this.total += this.totalesespecialidad_iva[especialidad];
                    }
                    console.log("listadotrabajosespecialidad1",this.listatrabajosporespecialidad);
                },1000);
            }
        },
        async obtenerTrabajosEspecialidad(){
            // POST  modulos/pwgsapi/index.php/servicios/id_servicio/baremo
            this.trabajos_especialidad = [];
            const api = new PwgsApi();
            let subidadatos = { id_especialidad: this.especialidadseleccionadaid };
            this.especialidades = await api.post('servicios/' + this.$props.id + '/baremo', subidadatos);
            for (let i = 0; i < this.especialidades.length; i++){
                let subidadatos = { codigo: this.especialidades[i].codigo, nombre: this.especialidades[i].nombre, idBaremo: this.especialidades[i].idtrabajo, precio: this.especialidades[i].precio };
                this.trabajos_especialidad.push(subidadatos);
            }
           /* if(this.especialidades){
                this.trabajos_especialidad =
                    this.especialidades.map(item => {
                return { codigo: item.codigo, nombre: item.nombre, idBaremo: item.idtrabajo, precio: item.precio };
            });
            }*/
        },
        async anyadirtrabajobaremo() { 
                // POST  modulos/pwgsapi/index.php/presupuestos/:id_trabajo/crear-trabajo Indicando id_especialidad e id_baremo.
            let idsBaremosSeleccionados = this.trabajo_especialidad_seleccionada.map(trabajo => trabajo.idBaremo);
    
                const api = new PwgsApi(); // Asumimos que esta API está correctamente configurada
                
                if (idsBaremosSeleccionados.length > 0) {
                    // Si hay selecciones, se envía un POST por cada ID de baremo seleccionado
                    for (let idBaremo of idsBaremosSeleccionados) {
                        let subidadatos = {
                            id_especialidad: this.especialidadseleccionadaid,
                            id_baremo: idBaremo
                        };
                        await api.post('presupuestos/' + this.$props.idaux + '/crear-trabajo', subidadatos);
                    }
                } else {
                    // Si no hay selecciones, se envía un POST sin el ID de baremo
                    let subidadatos = {
                        id_especialidad: this.especialidadseleccionadaid
                    };
                    await api.post('presupuestos/' + this.$props.idaux + '/crear-trabajo', subidadatos);
                }
                
                // Cargar datos actualizados después de todas las operaciones
                this.cargartrabajos();
                this.cargartrabajospresupuesto();            
                this.trabajo_especialidad_seleccionada = [];
        },
        cambiarImpuestos(value){
            var num = 0;
            for(var grupo of Object.entries(this.listatrabajosporespecialidad)){
                for(var x=0; x<grupo[1].length;x++){
                    //trabajo
                    this.$refs.presus[num].cambiarIva(value);
                    //console.log('num',num);
                    num++;
                }
            }
        },
        cambiarDest(value){
            var num = 0;
            for(var grupo of Object.entries(this.listatrabajosporespecialidad)){
                for(var x=0; x<grupo[1].length;x++){
                    //trabajo
                    this.$refs.presus[num].cambiarDest(value);
                    //console.log('num',num);
                    num++;
                }
            }
        },
        filtroBaremo(option) {
            if (typeof option === 'string') {
            // Si es una etiqueta "taggable" nueva
                return option;
            }
            return `${option.codigo} ${option.nombre}`;
        }
    },
    watch: {
        impuestoSelec(value){
            this.cambiarImpuestos(value);            
        },
        destSelec(value){
            this.cambiarDest(value);  
        },
        seleccionado() { 
            this.cargartrabajos();
            this.cargartrabajospresupuesto();
        },
        especialidadseleccionada(newValue) { 
            //this.cargartrabajoespecialidad();
            this.especialidadseleccionadaid = newValue.id;
            //alert("valor "+newValue.id);
            this.obtenerTrabajosEspecialidad();
            this.trabajo_especialidad_seleccionada = [];
        },
        id() {
            this.cargartrabajos();
            this.cargartrabajospresupuesto();
        },
        actualizarconceptos() {
             this.cargartrabajos();
             this.cargartrabajospresupuesto();
         },
         idaux(){
             this.cargartrabajos();
             this.cargartrabajospresupuesto();
         }
    }
})
</script>
